import React from 'react';
import styled from 'styled-components';
import CSLTable from '../Common/MCCTable';
import { FaPencilAlt,FaEdit, FaTimes,FaPlusCircle, FaEllipsisV } from "react-icons/fa";
import { IoIosCheckboxOutline, IoIosSquareOutline, IoIosWarning } from "react-icons/io";
import IncidentTypesConfigModal from './IncidentTypesConfigModal';
import Store from '../../Common/Store'
import AlertBox from '../Common/AlertBox';
import Toggle from 'react-toggle';
import "./ReactToggle.css";
import VerticalEllipsisMenuFolderReasonBreach from "./VerticalEllipsisMenuFolderReasonBreach";
import CSLLoader from './../Common/CSLLoader';

const SearchInput = styled.input`
    height: 30px;
    width: 98%;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    padding: 5px;
    color: #222222;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
`;
const MRButton = styled.button`
    box-sizing: border-box;
    background-color: #1E3E62;
    color: #ffffff;
    border: 1px solid #1E3E62;
    width: 37%;
    font-size: 13px;
    height: 43px;
    border-radius: 4px;
    display: inline-block;
    margin-left: 5px;
`;
const MRModalLabel = styled.div`
    color: #212121;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-block;
`;
const ExportButton = styled.button`
    box-sizing: border-box;
    background-color: #213E61;
    color: #F2F2F2;
    border: 1px solid #213E61;
    width: 125px;
    font-size: 14px;
    height: 32px;
    border-radius: 5px;
    margin-right: 3px;
    margin-top: 19px;
`;

const EmailContainer = styled.div`
	width: 100%;
`;
const EmailInnerContainer = styled.div`
	background-color: #ffffff;
	padding: 30px;
`;
const EmailBoldLabel = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 5px;
`;

const EmailTopHeader = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 5px;
	width:100%;
	height: 58px;
	padding: 20px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  box-sizing: border-box;
`;
const InactiveOverlay = styled.div`
  display: block;
  box-sizing: border-box;
  height: 210%;
  width: 100%;
  background-color: #ffffff;
  position: absolute;
  left: 0%;
  top: -46px;
  z-index: 1000;
  opacity: 0.8;
`;

class IncidentType extends React.Component
{
    state = {        
        incident_types: null,
        show_incident_types_array: null,
        incident_types_search: null,
        incidentTypesActiveArrayAll: null,
        incidentTypesInactiveArrayAll: null,
        ready: false,
        show_incident_types_modal: false,
        standard_incident_types: null,
        curid: 0,
        content: null,
        alert_param: null,
        headerText: "",
        isLoadedIcon: false
    };
    constructor(props) {
        super(props);        
    }

    componentDidMount()
	{		
		let incidentTypesActiveArrayAll = [];		
		let incidentTypesInactiveArrayAll = [];
		for(let i=0;i<this.props.incident_types.length;i++){
			if(this.props.incident_types[i].isActive === 1){
                incidentTypesActiveArrayAll.push(this.props.incident_types[i])
                incidentTypesInactiveArrayAll.push(this.props.incident_types[i])
			}else{
				incidentTypesInactiveArrayAll.push(this.props.incident_types[i])
			}
		}		
		
		this.setState({
			incident_types: this.props.incident_types,
			show_incident_types_array: this.props.incident_types,
			incident_types_search: this.props.incident_types,
			incidentTypesActiveArrayAll: incidentTypesActiveArrayAll,
            incidentTypesInactiveArrayAll: incidentTypesInactiveArrayAll,            
            ready: true,alert_param: null});
		console.log("incident_types===>",this.props.incident_types);
    }
    
    componentDidUpdate(prevProps)
	{
		if (prevProps !== this.props) {
			let incidentTypesActiveArrayAll = [];		
            let incidentTypesInactiveArrayAll = [];
            for(let i=0;i<this.props.incident_types.length;i++){
                if(this.props.incident_types[i].isActive === 1){
                    incidentTypesActiveArrayAll.push(this.props.incident_types[i])
                    incidentTypesInactiveArrayAll.push(this.props.incident_types[i])
                }else{
                    incidentTypesInactiveArrayAll.push(this.props.incident_types[i])
                }
            }		
            
            this.setState({
                incident_types: this.props.incident_types,
                show_incident_types_array: this.props.incident_types,
                incident_types_search: this.props.incident_types,
                incidentTypesActiveArrayAll: incidentTypesActiveArrayAll,
                incidentTypesInactiveArrayAll: incidentTypesInactiveArrayAll,            
                ready: true,alert_param: null,
                isLoadedIcon: false});
            console.log("incident_types===>",this.props.incident_types);			
		}
    } 

    handlenaSectionIncluded = (section_id) => (event) => {
		console.log("content:", section_id);
		let {show_incident_types_array} = this.state;
		let newshow_incident_types_array = [];
		show_incident_types_array.forEach((item) => {
			if (item.incidentTypeID === section_id) {
				item.isActive = item.isActive === 1 ? 0 : 1; 				
			}
			newshow_incident_types_array.push(item);
		})
		console.log("emails:", newshow_incident_types_array);
        this.setState({isLoadedIcon: true})
		this.props.updateshow_incident_types(newshow_incident_types_array);
	}

    showConfigModal = (curid, isdelete) => (obj) => {
		console.log("curid==>", curid)
		console.log("obj==>", obj)
		if(obj === 'Edit'){			
            const content = this.state.incident_types.find((item) => {
                return item.incidentTypeID === curid;
            })
            this.setState({content,curid: curid, show_incident_types_modal: true, headerText: "Edit"});   
		}else if(obj === 'Delete'){
            if(isdelete === 0){
                let alert_param = {title: 'Warning', message: 'Are you sure you want to delete this Incident type from the list?', ok_text: 'Yes', cancel_text: 'No', confirm: true, 
                           alertHandler: this.updatedeleteIncidentType, stack: {id: curid}}
                this.setState({alert_param: alert_param})
            }else{
                let alert_param = {title: 'ERROR', message: 'This Incident type has already been used.', ok_text: 'Ok', confirm: false, 
                           alertHandler: this.updateafternodelete, stack: {}}
                this.setState({alert_param: alert_param})
            }			
		}
	};

    updatedeleteIncidentType = (result, stack) => {  
        if(!result) {
            this.setState({alert_param: null})
            return
        }
        console.log("id",stack.id)           	
        let newreason = [];
        for(let i=0;i<this.state.incident_types.length;i++)
        {
            if(this.state.incident_types[i].incidentTypeID !== stack.id){
                newreason.push(this.state.incident_types[i])
            }
        }			 
        console.log("delete===>",newreason);   
        this.props.deleteIncidentTypesValue(newreason);
    }

    updateafternodelete = (result, stack) => {
        console.log(result,stack)
        this.setState({alert_param: null})        
    }  

    tableData = () => {
        console.log("this.state.show_incident_types_array",this.state.show_incident_types_array)
        let ret = {data: [], columns: []};
        ret.columns =[
                        {Header: 'Name', accessor: 'name', minWidth: 240, headerStyle: {textAlign: 'left'}},					
						{'Header' : 'Status', Cell: row => (
							<div> 
							<Toggle
								style={{float:'left'}}
								defaultChecked={row.original.status === "Active" ? true : false}
								icons={false}	
                                onChange={this.handlenaSectionIncluded(row.original.id)}						
							/>
							</div>
						 ), headerStyle:{textAlign: 'center'},style: {textAlign: 'center'}},						
                        {'Header' : '', Cell: row => (
                            <div>                                
                                  <VerticalEllipsisMenuFolderReasonBreach editDelete={this.showConfigModal(row.original.id, row.original.isdelete)} options={["Edit", "Delete"]} />	
                            </div>
                         ), minWidth: 40, headerStyle:{textAlign: 'left'},style: {textAlign: 'center'}}
                        ];

        let incident_types_sort_array = this.state.show_incident_types_array.sort(function(a,b) {return (a.incidentTypeName > b.incidentTypeName) ? 1 : ((b.incidentTypeName > a.incidentTypeName) ? -1 : 0);} );
		incident_types_sort_array.forEach((item) => {
			let statusValue = item.isActive === 1 ? "Active" : "Inactive"
			let elem = {id: item.incidentTypeID, name: item.incidentTypeName, status: statusValue, isdelete: item.isDelete};
			ret.data.push(elem);
        })
        return ret;
    }   
    
    addIncidentType = (event) => {
		event.preventDefault();
		this.setState({show_incident_types_modal: true,curid: 0, headerText: "Add"})
    }
    closeModal = () => {		
		this.setState({show_incident_types_modal: false})
    }
    
    saveIncidentTypeValue = (obj) => {
		this.setState({show_incident_types_modal: false, isLoadedIcon: true})
		this.props.saveIncidentTypesValue(obj)
    }

    updateIncidentTypesValue = (content) => {
		console.log("content:", content);
		//console.log("this.state",this.state.reason_for_removal)
		let {incident_types} = this.state;
		let newreason = [];
		incident_types.forEach((item) => {
			if (item.incidentTypeID === content.incidentTypeID) {
				item = content;
				console.log("matched", item);
			}
			newreason.push(item);
		})
		console.log("resons:", newreason);
		this.setState({show_incident_types_modal: false, isLoadedIcon: true})
		this.props.updateIncidentTypesValue(newreason);		
	}
    
    
    render()    
	{
        if (!this.state.ready) {
			return (<div>Loading...</div>);
		}          
		return(
        <div>            
            <div>
                    {
                        (() => {
                            if (this.state.show_incident_types_modal) {
                                return (<div ><InactiveOverlay style={{height: "105%"}}/><IncidentTypesConfigModal headerText={this.state.headerText} closeModal={this.closeModal} curid={this.state.curid} content={JSON.parse(JSON.stringify(this.state.content))} updateIncidentTypesValue={this.updateIncidentTypesValue} saveIncidentTypeValue={this.saveIncidentTypeValue}/></div>);
                            }
                        })()
                    }
                    {
                        (() => {
                            if(this.state.isLoadedIcon){
                                return <div><CSLLoader style={{position: 'absolute'}}/></div>
                            }
                        })()
                    }
                     
                    <EmailContainer>
                        <EmailInnerContainer>
                             
                            <EmailTopHeader style={{display: "inline-block" , fontWeight: 700}}>
								Incident Types                                
                                <div style={{float:'right'}}>
                                    <div onClick={this.addIncidentType}  style={{float: "left", cursor: "pointer",fontSize: "25px",color: "#04ADA8"}}>
                                        <FaPlusCircle  /> 
                                    </div>                            
                                    <div style={{float: "right", cursor: "pointer",fontSize: "25px",color: "#e4e4e4"}}>
                                        <FaEllipsisV  /> 
                                    </div>
                                </div>
							</EmailTopHeader>
                            <CSLTable add={false} processData={this.tableData} tableRows={10} />
                        </EmailInnerContainer>
                    </EmailContainer>
            </div>
            <AlertBox alertParam = {this.state.alert_param}/>
        </div>
        );
	}
}

export default IncidentType;